// extracted by mini-css-extract-plugin
export default {"swatch":"swatch--UwD0k","swatch__split":"swatch__split--Fb2Ke"};